import { type ReactNode } from "react";
import { MoreVertical } from "lucide-react";
import { cn } from "../../lib/utils";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "./dropdown-menu";

export interface ActionMenuItem { label: string; icon?: ReactNode; danger?: boolean; onClick: () => void }

export function ActionMenu({ items, ariaLabel }: { items: ActionMenuItem[]; ariaLabel: string }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          aria-label={ariaLabel}
          onClick={(e) => e.stopPropagation()}
          className="rounded-lg p-1.5 text-ink-3 opacity-0 transition-all hover:bg-soft hover:text-ink focus:opacity-100 group-hover:opacity-100"
        >
          <MoreVertical className="h-4 w-4" />
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48 rounded-xl border border-line bg-elevated shadow-lg p-1.5 z-50">
        {items.map((it) => (
          <DropdownMenuItem
            key={it.label}
            onClick={(e) => { e.stopPropagation(); it.onClick(); }}
            className={cn(
              "flex w-full items-center gap-2.5 px-3 py-2 cursor-pointer rounded-lg text-sm transition-colors",
              it.danger ? "text-danger focus:bg-danger-soft focus:text-danger hover:bg-danger-soft" : "text-ink-2 focus:bg-soft focus:text-ink hover:bg-soft hover:text-ink",
            )}
          >
            {it.icon}{it.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
